import { render, staticRenderFns } from "./AppSelectField.vue?vue&type=template&id=6008ffa6&scoped=true&"
import script from "./AppSelectField.vue?vue&type=script&lang=js&"
export * from "./AppSelectField.vue?vue&type=script&lang=js&"
import style0 from "./AppSelectField.vue?vue&type=style&index=0&id=6008ffa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6008ffa6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6008ffa6')) {
      api.createRecord('6008ffa6', component.options)
    } else {
      api.reload('6008ffa6', component.options)
    }
    module.hot.accept("./AppSelectField.vue?vue&type=template&id=6008ffa6&scoped=true&", function () {
      api.rerender('6008ffa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppSelectField.vue"
export default component.exports